module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/U5h17F/tc-custom/9781452125114.jpg?1737758515140",
      "alt": "This image is the cover for the book Delicious Dips"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Delicious Dips\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The James Beard Award–winning author of "), _c('i', [_vm._v("Roots")]), _vm._v(" and "), _c('i', [_vm._v("Salmon")]), _vm._v(" offers more than fifty original recipes for fun, festive dips and chips.")]), _c('br'), _c('br'), _vm._v("Diane Morgan—the diva of dips and champion of chips—has created more than fifty recipes for everyone’s dipping and dunking party favorites. Guests will make a beeline for lip-buzzing salsas scooped up with crispy tortilla triangles. Onion dip made from scratch is even better with homemade potato chips. And how about crunchy Parmesan Breadsticks for dunking into a butternut squash with creme fraiche?"), _c('br'), _c('br'), _vm._v("Simple “Dip Do-Aheads” make prep work a snap, while dip tips and easy chip-making techniques make it easier—and tastier—than the typical store-bought alternatives. Let the party begin with "), _c('i', [_vm._v("Delicious Dips")]), _vm._v("!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Diane Morgan, Joyce Oudkerk Pool\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Diane Morgan is an experienced cooking teacher and the author of many cookbooks, including the best-selling Atomic Cocktails (0-8118-1926-4), Midnight Munchies (0-8118-3534-0), Dressed to Grill (0-8118-3139-6), and The Thanksgiving Table (0-8118-2991-X), all from Chronicle Books. She lives in Portland, Oregon.Joyce Oudkerk Pool is an award-winning photographer specializing in food. Her photographs appear in a number of cookbooks including James McNair's New Pizza (0-8118-2364-4).")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0